import React, { useState, useEffect } from 'react';
import { Check } from 'react-feather';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import MediaPlayer from 'components/ui/MediaPlayer';
import UniversalPlayer from 'components/shared/UniversalPlayer';

import RetryButton from 'components/Practice/shared/RetryButton';
import Skeleton from 'ui/Skeleton';
import SubmittedUserResponse from './shared/SubmittedUserResponse';
import RecordingQuestionResponse from './RecordingQuestionResponse';

const RecordingQuestionResponses = props => {
  const {
    meta,
    userResponses,
    handleOptionsChange,
    currentChoice,
    resetAnswer,
    skipped,
    setSkipped,
    technicalDifficultiesReported,
    setUserResponseToDelete,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userResponses.length) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [userResponses]);

  const attemptIsCurrentChoice = userResponse => {
    return (
      currentChoice !== undefined &&
      currentChoice !== null &&
      currentChoice.givenAnswer === userResponse.givenAnswer
    );
  };

  return (
    <div>
      {skipped && (
        <div className="border-bottom border-gray-light ml-32 mr-32 pt-24 pb-28 d-f fd-r">
          <Check size="2rem" className="mr-4 c-success" />
          <Text
            className="c-success as-c"
            variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
          >
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.success.success_message',
            )}
          </Text>
        </div>
      )}
      {technicalDifficultiesReported && (
        <div className="ml-32 pt-24 d-f fd-r">
          <Check size="2rem" className="mr-4 c-success" />
          <Text
            className="c-success as-c"
            variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
          >
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.success.success_short',
            )}
          </Text>
        </div>
      )}
      <div className="ml-32 mr-32 mb-32 mt-30">
        {skipped && !meta.finished ? (
          <div className="d-f ai-c fw-w">
            <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="mr-4">
              {t(
                'practice.on_demand_practice.audio_recording.skip_recording.my_responses.retry_message',
              )}
            </Text>
            <RetryButton onClick={resetAnswer} />
          </div>
        ) : (
          !meta.finished && (
            <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
              {t('practice.repeatability.choose_response')}
            </Text>
          )
        )}
      </div>
      <div className="d-f fd-c WebcamResponses">
        {isLoading ? (
          <div className="mr-32 ml-32">
            <Skeleton height="300px" />
          </div>
        ) : (
          userResponses.map((userResponse, index) => (
            <div
              className="d-f m-fd-rc WebcamResponse--userResponse"
              key={userResponse.id}
            >
              {userResponse.answerSubmittedDate &&
              userResponse.isAnswer === true ? (
                <SubmittedUserResponse
                  response={userResponse}
                  version={userResponses.length - index}
                  completedAt={userResponse.answerSubmittedDate}
                />
              ) : (
                <RecordingQuestionResponse
                  userResponse={userResponse}
                  setUserResponseToDelete={setUserResponseToDelete}
                  attemptIsCurrentChoice={attemptIsCurrentChoice}
                  handleOptionsChange={handleOptionsChange}
                  version={userResponses.length - index}
                  finished={meta.finished}
                  setSkipped={setSkipped}
                />
              )}
              {userResponse.recording?.provider === 'seismic' && (
                <UniversalPlayer
                  key={userResponse.id}
                  id={userResponse.recording.id}
                  videoType="Recording"
                  isPractice
                />
              )}
              {userResponse.recording?.provider !== 'seismic' && (
                <MediaPlayer
                  key={userResponse.id}
                  hasZiggeoForAllMedia
                  customClass="QuestionElement--attempt w-fill"
                  customIframeClass="QuestionElement--iframeRepeatableAttempt"
                  recording={userResponse.recording}
                  ziggeoApiKey={meta.apiKey}
                />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecordingQuestionResponses;
